import React, { useCallback } from 'react';
import { Button } from '@framework-controls/core';
import { JSXIf } from '@framework-controls/jsxconditions';
import css from './MenuSlideBtn.module.scss';
import classNames from 'classnames';

interface IProps {
    id: string;
    lit?: string;
    icon?: React.ReactElement;
    openFlag: boolean;
    click: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    toolTip?: string;
    theme: string;
}

const MenuSlideBtn = (props: IProps) => {
    // Set contentsClassName based on openFlag (open flag indicates if the menuSlide is open or closed)
    const contentsClassName = classNames(
        css.menuSlideBtnContents,
        {
            [css.menuSlideBtnContentsIN]: props.theme === 'infiniti',
            [css.menuSlideBtnContentsChecked]: props.openFlag,
            [css.menuSlideBtnContentsCheckedFord]: props.theme === 'ford',
            [css.menuSlideBtnContentsNissan]: props.theme === 'nissan',
            [css.menuSlideBtnContentsGMC]: props.theme === 'gmc',
            [css.menuSlideBtnContentsAcura]: props.theme === 'acura',
        },
    );

    // Set subBtnClassName based on openFlag
    const subBtnClassName = classNames(
        css.menuSlideSubBtn,
        {
            [css.menuSlideSubBtnChecked]: props.openFlag,
            [css.menuSlideBtnCheckedAudi]: props.openFlag && props.theme === 'audi',
            [css.menuSlideBtnCheckedChevrolet]: props.openFlag && props.theme === 'chevrolet',
            [css.menuSlideBtnCheckedBuick]: props.openFlag && props.theme === 'buick',
            [css.menuSlideSubBtnMaz]: props.theme === 'mazda',
            [css.menuSlideSubBtnJag]: props.theme === 'jaguar',
        },
    );

    const onClick = useCallback((event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        event.preventDefault();
        props.click(event);
    }, [props.click]);
    // Set displayBtn flag base on if we have a literal for the button.
    // We still want to display the Div wrapper to reserve the space for the button in the menu.
    let displayBtn = true;
    if (!props.lit) {
        displayBtn = false;
    }

    return (
        <div className={subBtnClassName}>
            <JSXIf Condition={displayBtn}>
                <Button
                    id={props.id + '1'}
                    onClick={onClick}
                    variant={'menuSlideBtn'}
                    type={'custom'}
                    tooltip={props.toolTip ? props.toolTip : ''}
                >
                    <span className={contentsClassName}>
                        {props.icon}
                    </span>
                    <div className={contentsClassName}>{props.lit}</div>
                </Button>
            </JSXIf>
        </div>
    );
};

export default MenuSlideBtn;